import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import style from './IdCardPrinterBoard.module.sass';

// Mirrors app/javascript/controllers/school_search_controller.js's debounce
// and minimum-length behavior (200ms, 2 chars) so this feels consistent with
// the school picker used elsewhere in the admin.
const DEBOUNCE_MS = 200;
const MIN_QUERY_LENGTH = 2;

const AddSchoolForm = ({ onAddSchool, schoolSearchUrl, disabled }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const timeoutRef = useRef(null);

  useEffect(() => {
    clearTimeout(timeoutRef.current);
    const trimmed = query.trim();
    if (trimmed.length < MIN_QUERY_LENGTH) {
      setResults([]);
      return () => {};
    }

    timeoutRef.current = setTimeout(async () => {
      try {
        const response = await axios.get(schoolSearchUrl, { params: { q: trimmed } });
        setResults(response.data || []);
      } catch (requestError) {
        setResults([]);
      }
    }, DEBOUNCE_MS);

    return () => clearTimeout(timeoutRef.current);
  }, [query, schoolSearchUrl]);

  const choose = (school) => {
    onAddSchool(school.id);
    setQuery('');
    setResults([]);
  };

  return (
    <div className={style.addForm}>
      <input
        type="text"
        className="form-control"
        placeholder="Type a school name or SCODE…"
        autoComplete="off"
        value={query}
        disabled={disabled}
        onChange={(event) => setQuery(event.target.value)}
      />
      {results.length > 0 && (
        <ul className={style.schoolSearchResults}>
          {results.map((school) => (
            <li key={school.id} className={style.schoolSearchOption}>
              <button type="button" onClick={() => choose(school)}>
                {school.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

AddSchoolForm.propTypes = {
  onAddSchool: PropTypes.func.isRequired,
  schoolSearchUrl: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default AddSchoolForm;
